import { useAuth } from './useAuth';
import { useCurrentUser } from './useCurrentUser';
import { usePermissions } from './usePermissions';

export const useAdmin = () => {
  const { user: authUser } = useAuth();
  const { data: currentUser } = useCurrentUser();
  const { canAccessAdminPanel, isStaff } = usePermissions();
  
  return {
    isAdmin: canAccessAdminPanel,
    isStaff,
    user: authUser,
    currentUser,
    hasAdminAccess: () => canAccessAdminPanel,
    requireAdmin: () => {
      if (!canAccessAdminPanel) {
        throw new Error('Staff access required for admin panel');
      }
    }
  };
};